import React from "react";
import { Card } from "react-bootstrap";
import ReactECharts from "echarts-for-react";
import './style.css';

const AuditQuality: React.FC = () => {
  const radarOption = {
    tooltip: {},
    legend: {
      bottom: 0,
      data: ['AI Feedback', 'Reviewer Feedback'],
      textStyle: {
        fontSize: 12,
      },
    },
    radar: {
      indicator: [
        { text: 'Response Level I', max: 5 },
        { text: 'Response Level II', max: 5 },
        { text: 'Response Level III', max: 5 },
        { text: 'Response Level IV', max: 5 },
        { text: 'Response Level V', max: 5 },
      ],
      shape: 'polygon',
      radius: '60%',
      splitNumber: 5,
      splitLine: {
        lineStyle: {
          color: '#ccc',
        },
      },
      splitArea: {
        areaStyle: {
          color: ['#fff'],
        },
      },
      axisLine: {
        lineStyle: {
          color: '#999',
        },
      },
    },
    series: [
      {
        type: 'radar',
        areaStyle: {},
        label: {
          show: true,
          color: '#000',
          fontSize: 12,
        },
        data: [
          {
            value: [4, 4, 3, 3, 4],
            name: 'AI Feedback',
            itemStyle: { color: '#8979FF' },
            lineStyle: { color: '#8979FF' },
          },
          {
            value: [2, 3, 5, 1, 4],
            name: 'Reviewer Feedback',
            itemStyle: { color: '#FF928A' },
            lineStyle: { color: '#FF928A' },
          },
        ],
      },
    ],
  };
  return (
    <Card.Body>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <h6
          className="fw-bold mb-0"
          style={{ fontSize: "15px", color: "#102250" }}
        >
          Audit Quality Metrics
        </h6>
      </div>
      <div className="d-flex">
        <div className="col-6">
          <div className="my-3 overalltitle my-2">Response Quality:</div>
          <ReactECharts option={radarOption} />
        </div>
        <div className="col-6">
          <div className="my-3 overalltitle my-2">Rework Metrics:</div>
          <div className="custom_scroll maxlenght">
            <div className="subTitle">Tasks or findings requiring revisions</div>
            <div className="my-2">Reasons for rework (e.g., unclear documentation). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada diam eu dolor mattis pulvinar ut non lorem</div>
            <div className="subTitle">Tasks or findings requiring revisions</div>
            <div className="my-2">Reasons for rework (e.g., unclear documentation). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada diam eu dolor mattis pulvinar ut non lorem</div>
            <div className="subTitle">Tasks or findings requiring revisions</div>
            <div className="my-2">Reasons for rework (e.g., unclear documentation). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada diam eu dolor mattis pulvinar ut non lorem</div>
            <div className="subTitle">Tasks or findings requiring revisions</div>
            <div className="my-2">Reasons for rework (e.g., unclear documentation). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada diam eu dolor mattis pulvinar ut non lorem</div>
            <div className="subTitle">Tasks or findings requiring revisions</div>
            <div className="my-2">Reasons for rework (e.g., unclear documentation). Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris malesuada diam eu dolor mattis pulvinar ut non lorem</div>
          </div>
        </div>
      </div>
    </Card.Body>
  );
};

export default AuditQuality;
